var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173 936q-24 0-42-18t-18-42V669q0-24 18-42t42-18h462V432h60v177h104q24 0 42 18t18 42v207q0 24-18 42t-42 18H173Zm626-60V669H173v207h626ZM311 772.895Q311 755 298.895 743q-12.106-12-30-12Q251 731 239 743.105q-12 12.106-12 30Q227 791 239.105 803q12.106 12 30 12Q287 815 299 802.895q12-12.106 12-30Zm148 0Q459 755 446.895 743q-12.106-12-30-12Q399 731 387 743.105q-12 12.106-12 30Q375 791 387.105 803q12.106 12 30 12Q435 815 447 802.895q12-12.106 12-30ZM565.105 815Q583 815 595 802.895q12-12.106 12-30Q607 755 594.895 743q-12.106-12-30-12Q547 731 535 743.105q-12 12.106-12 30Q523 791 535.105 803q12.106 12 30 12ZM585 389l-41-41q24-24 54.431-38 30.432-14 66.569-14t66.569 14Q762 324 786 348l-41 41q-14-14-35-23.5t-44.5-9.5q-23.5 0-45 9.5T585 389Zm-85-85-44-44q33-33 88-58.5T665 176q66 0 121 25.5t88 58.5l-44 44q-26-29-68.5-48.5T665 236q-54 0-96.5 19.5T500 304ZM173 876V669v207Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.62c86475920b9bfcf6d49f200d76cc96.svg";
export { ForwardRef as ReactComponent };